import { IconButton } from "@/components/ui/icon-button";
import Text from "@/components/ui/text";
import { ChevronRight } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";

interface Props {
  // 1-based position of the version currently shown.
  current: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
  className?: string;
}

// Version navigator shown at the bottom of the card once a draft has more than
// one version (e.g. "‹ 2/2 ›"). There is no dedicated left chevron in the icon
// set, so the right chevron is rotated for the previous-version control.
const DraftEmailVersionNav = ({
  current,
  total,
  onPrev,
  onNext,
  disabled,
  className
}: Props) => (
  <div
    className={cn("flex items-center justify-start gap-1 py-2 pl-2", className)}
    data-test="draft-email-version-nav"
  >
    <IconButton
      variant="iconNoBg"
      size="xs"
      iconColor="tertiary"
      iconClassName="rotate-180"
      onClick={onPrev}
      disabled={disabled || current <= 1}
      aria-label="previous version"
    >
      <ChevronRight />
    </IconButton>
    <Text as="span" variant="bodySecondary" className="cursor-default">
      {`${current}/${total}`}
    </Text>
    <IconButton
      variant="iconNoBg"
      size="xs"
      iconColor="tertiary"
      onClick={onNext}
      disabled={disabled || current >= total}
      aria-label="next version"
    >
      <ChevronRight />
    </IconButton>
  </div>
);

export default DraftEmailVersionNav;
